/**
 * 订单相关请求模块
 */
// import qs from 'qs'
import request from '@/utils/request'

export const getOrderSetup = () => {
  return request({
    method: 'GET',
    url: '/cms/shop_payments/setup'
  })
}

export const getOrderQueryList = (params) => {
  return request({
    method: 'GET',
    url: '/cms/shop_payments',
    params
  })
}

export const getOrderExport = (data) => {
  return request({
    method: 'post',
    url: '/cms/shop_payments/export',
    data
    // responseType: 'blob'
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

export const getOrderSalesReport = (data) => {
  return request({
    method: 'post',
    url: '/cms/shop_payments/generate_sales_report',
    data
  })
}

export const getOrderFeeSet = (data) => {
  return request({
    method: 'post',
    url: '/cms/shop_payments/generate_delivery_fee_settlement',
    data
  })
}

export const getOrderDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/shop_payments/${id}`
  })
}

export const getDeliveryOrderSetup = () => {
  return request({
    method: 'GET',
    url: '/cms/delivery_orders/setup'
  })
}

export const getDeliveryOrderQueryList = (params) => {
  return request({
    method: 'GET',
    url: '/cms/delivery_orders',
    params
  })
}

export const getDeliveryOrderExport = (data) => {
  return request({
    method: 'post',
    url: '/cms/delivery_orders/export',
    data
    // responseType: 'blob',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

export const getDeliveryOrderDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/delivery_orders/${id}`
  })
}

export const getAfterSaleOrderSetup = () => {
  return request({
    method: 'GET',
    url: '/cms/after_sales_orders/setup'
  })
}

export const getAfterSaleOrderQueryList = (params) => {
  return request({
    method: 'GET',
    url: '/cms/after_sales_orders',
    params
  })
}

export const getAfterSaleOrderDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/after_sales_orders/${id}`
  })
}

export const getBreakDownOrderSetup = () => {
  return request({
    method: 'GET',
    url: '/cms/shop_payment_items/setup'
  })
}

export const getBreakDownOrderQueryList = (params) => {
  return request({
    method: 'GET',
    url: '/cms/shop_payment_items',
    params
  })
}

export const gettBreakDownOrderExport = (data) => {
  return request({
    method: 'post',
    url: '/cms/shop_payment_items/export',
    data
    // responseType: 'blob',
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

export const getBreakDownOrderDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/shop_payment_items/${id}`
  })
}

export const getFileList = (params) => {
  return request({
    method: 'GET',
    url: '/cms/export_jobs',
    params
  })
}

export const getFileSetup = () => {
  return request({
    method: 'GET',
    url: '/cms/export_jobs/setup'
  })
}

export const getDeliverDate = (id) => {
  return request({
    method: 'GET',
    url: `/cms/delivery_orders/${id}/available_delivery_dates`
  })
}

export const getOrderAfterSalesReport = (data) => {
  return request({
    method: 'post',
    url: '/cms/after_sales_orders/export',
    data
  })
}

export const getTicketOrderSetup = () => {
  return request({
    method: 'GET',
    url: '/cms/ticketing_payments/setup'
  })
}

export const getTicketOrderQueryList = (params) => {
  return request({
    method: 'GET',
    url: '/cms/ticketing_payments',
    params
  })
}

export const getTicketingOrderDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/ticketing_payments/${id}`
  })
}

export const getHotelOrderSetup = () => {
  return request({
    method: 'GET',
    url: '/cms/hotel_payments/setup'
  })
}

export const getHotelOrderList = (params) => {
  return request({
    method: 'GET',
    url: '/cms/hotel_payments',
    params
  })
}

export const getHotelOrderDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/hotel_payments/${id}`
  })
}

export const getDineinOrderSetup = () => {
  return request({
    method: 'GET',
    url: '/cms/dine_in_orders/setup'
  })
}

export const getDineinOrderQueryList = (params) => {
  return request({
    method: 'GET',
    url: '/cms/dine_in_orders',
    params
  })
}

export const getDineinOrderExport = (data) => {
  return request({
    method: 'post',
    url: '/cms/dine_in_orders/export',
    data
    // responseType: 'blob'
    // headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}

export const getDineinOrderSalesReport = (data) => {
  return request({
    method: 'post',
    url: '/cms/dine_in_orders/generate_sales_report',
    data
  })
}

export const getDineinOrderFeeSet = (data) => {
  return request({
    method: 'post',
    url: '/cms/dine_in_orders/generate_delivery_fee_settlement',
    data
  })
}

export const getDineinOrderDetails = (id) => {
  return request({
    method: 'GET',
    url: `/cms/dine_in_orders/${id}`
  })
}
